import React, { useState, useEffect } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Paper,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from "@mui/material";
// import "./DisplayYoutubeVideos.css";

const DisplayYoutubeVideos = () => {
  const API_URL = process.env.REACT_APP_API_URL;

  const [videos, setVideos] = useState([]);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const [openDetails, setOpenDetails] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);

  const [selectedVideo, setSelectedVideo] = useState(null);
  const [formData, setFormData] = useState({});

  // ================= SEARCH =================
  const [search, setSearch] = useState("");

  // ================= FETCH ALL =================
  useEffect(() => {
    fetchVideos();
  }, []);

  const fetchVideos = async () => {
    try {
      const response = await fetch(
        `${API_URL}/v1/youtube-videos`
      );

      const result = await response.json();

      setVideos(result || []);
    } catch (error) {
      console.error("Error fetching videos:", error);
    }
  };


  // ================= SEARCH =================
  const handleSearch = (value) => {
    setSearch(value);

    if (!value) {
      fetchVideos();
      return;
    }

    const filtered = videos.filter(
      (video) =>
        video.title
          ?.toLowerCase()
          .includes(value.toLowerCase()) ||
        video.language
          ?.toLowerCase()
          .includes(value.toLowerCase()) ||
        video.youtubeVideoId
          ?.toLowerCase()
          .includes(value.toLowerCase())
    );

    setVideos(filtered);
  };


  // ================= PAGINATION =================

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };


  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(
      parseInt(event.target.value, 10)
    );
    setPage(0);
  };


  // ================= OPEN DIALOGS =================

  const handleOpenDetails = (video) => {
    setSelectedVideo(video);
    setOpenDetails(true);
  };


  const handleOpenEdit = (video) => {
    setSelectedVideo(video);
    setFormData(video);
    setOpenEdit(true);
  };


  const handleOpenDelete = (video) => {
    setSelectedVideo(video);
    setOpenDelete(true);
  };


  const handleCloseDialogs = () => {
    setOpenDetails(false);
    setOpenEdit(false);
    setOpenDelete(false);
    setSelectedVideo(null);
    setFormData({});
  };


  // ================= INPUT CHANGE =================

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };


  // ================= UPDATE VIDEO =================

  const handleUpdate = async () => {
    try {
      const response = await fetch(
        `${API_URL}/v1/youtube-videos/${selectedVideo.id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );


      const result = await response.json();


      if (response.ok) {
        fetchVideos();
      } else {
        console.error(result.error);
      }

    } catch (error) {
      console.error(
        "Update error:",
        error
      );
    } finally {
      handleCloseDialogs();
    }
  };



  // ================= DELETE VIDEO =================

  const handleDelete = async () => {
    try {
      const response = await fetch(
        `${API_URL}/v1/youtube-videos/${selectedVideo.id}`,
        {
          method: "DELETE",
        }
      );


      if (response.ok) {
        setVideos((prev) =>
          prev.filter(
            (v) =>
              v.id !== selectedVideo.id
          )
        );
      }

    } catch (error) {
      console.error(
        "Delete error:",
        error
      );
    } finally {
      handleCloseDialogs();
    }
  };



  return (
    <>

      {/* ================= SEARCH ================= */}

      <div className="search-box">

        <TextField
          fullWidth
          label="Search YouTube videos..."
          value={search}
          onChange={(e) =>
            handleSearch(e.target.value)
          }
          sx={{ mb: 2 }}
        />

      </div>



      {/* ================= TABLE ================= */}

      <TableContainer component={Paper}>

        <Table>

          <TableHead>

            <TableRow>

              <TableCell>ID</TableCell>

              <TableCell>Title</TableCell>

              <TableCell>YouTube ID</TableCell>

              <TableCell>Language</TableCell>

              <TableCell>Sort Order</TableCell>

              <TableCell>Actions</TableCell>

            </TableRow>

          </TableHead>



          <TableBody>

            {videos
              .slice(
                page * rowsPerPage,
                page * rowsPerPage + rowsPerPage
              )
              .map((video) => (

                <TableRow key={video.id}>


                  <TableCell>
                    {video?.id}
                  </TableCell>


                  <TableCell>
                    {video?.title}
                  </TableCell>


                  <TableCell>
                    {video?.youtubeVideoId}
                  </TableCell>


                  <TableCell>
                    {video?.language}
                  </TableCell>


                  <TableCell>
                    {video?.sortOrder}
                  </TableCell>



                  <TableCell
                    sx={{
                      display:"flex",
                      flexDirection:"column",
                      gap:1,
                    }}
                  >

                    <Button
                      variant="contained"
                      size="small"
                      color="primary"
                      onClick={() =>
                        handleOpenEdit(video)
                      }
                    >
                      Edit
                    </Button>


                    <Button
                      variant="contained"
                      size="small"
                      color="error"
                      onClick={() =>
                        handleOpenDelete(video)
                      }
                    >
                      Delete
                    </Button>


                    <Button
                      variant="outlined"
                      size="small"
                      color="info"
                      onClick={() =>
                        handleOpenDetails(video)
                      }
                    >
                      View
                    </Button>


                  </TableCell>


                </TableRow>

              ))}

          </TableBody>


        </Table>



        <TablePagination

          rowsPerPageOptions={[
            5,
            10,
            25
          ]}

          component="div"

          count={videos.length}

          rowsPerPage={rowsPerPage}

          page={page}

          onPageChange={
            handlePageChange
          }

          onRowsPerPageChange={
            handleRowsPerPageChange
          }

        />


      </TableContainer>





      {/* ================= DETAILS DIALOG ================= */}


      <Dialog
        open={openDetails}
        onClose={handleCloseDialogs}
      >

        <DialogTitle>
          YouTube Video Details
        </DialogTitle>


        <DialogContent>


          <Typography>
            <b>ID:</b> {selectedVideo?.id}
          </Typography>


          <Typography>
            <b>Title:</b> {selectedVideo?.title}
          </Typography>


          <Typography>
            <b>YouTube ID:</b> {selectedVideo?.youtubeVideoId}
          </Typography>


          <Typography>
            <b>Description:</b> {selectedVideo?.description}
          </Typography>


          <Typography>
            <b>Language:</b> {selectedVideo?.language}
          </Typography>


          <Typography>
            <b>Sort Order:</b> {selectedVideo?.sortOrder}
          </Typography>


        </DialogContent>



        <DialogActions>

          <Button
            onClick={handleCloseDialogs}
          >
            Close
          </Button>

        </DialogActions>


      </Dialog>






      {/* ================= EDIT DIALOG ================= */}


      <Dialog
        open={openEdit}
        onClose={handleCloseDialogs}
      >

        <DialogTitle>
          Edit YouTube Video
        </DialogTitle>


        <DialogContent>


          <TextField
            label="Title"
            name="title"
            value={
              formData.title || ""
            }
            onChange={
              handleInputChange
            }
            fullWidth
            margin="dense"
          />



          <TextField
            label="YouTube Video ID"
            name="youtubeVideoId"
            value={
              formData.youtubeVideoId || ""
            }
            onChange={
              handleInputChange
            }
            fullWidth
            margin="dense"
          />



          <TextField
            label="Description"
            name="description"
            value={
              formData.description || ""
            }
            onChange={
              handleInputChange
            }
            fullWidth
            multiline
            rows={3}
            margin="dense"
          />



          <TextField
            label="Language"
            name="language"
            value={
              formData.language || ""
            }
            onChange={
              handleInputChange
            }
            fullWidth
            margin="dense"
          />



          <TextField
            label="Sort Order"
            name="sortOrder"
            value={
              formData.sortOrder || ""
            }
            onChange={
              handleInputChange
            }
            fullWidth
            margin="dense"
          />


        </DialogContent>



        <DialogActions>


          <Button
            onClick={handleCloseDialogs}
            color="secondary"
          >
            Cancel
          </Button>



          <Button
            onClick={handleUpdate}
            color="primary"
          >
            Save
          </Button>


        </DialogActions>


      </Dialog>







      {/* ================= DELETE DIALOG ================= */}


      <Dialog
        open={openDelete}
        onClose={handleCloseDialogs}
      >

        <DialogTitle>
          Delete Video
        </DialogTitle>


        <DialogContent>

          Are you sure you want to delete{" "}

          <b>
            {selectedVideo?.title}
          </b>
          ?

        </DialogContent>



        <DialogActions>


          <Button
            onClick={handleCloseDialogs}
          >
            Cancel
          </Button>



          <Button
            onClick={handleDelete}
            color="error"
          >
            Delete
          </Button>


        </DialogActions>


      </Dialog>



    </>
  );
};


export default DisplayYoutubeVideos;